import React from "react";
import {
    Image,
    Flex
} from "@chakra-ui/react";


import ImageGrid from "../components/ImageGrid";

import images from "../data/images.json"


export default function Gallery() {
    return (
        <>
            <ImageGrid
                items={images}
                title={"Render Jam Results"}
                subtitle={"These images were created by club members during our workshops and events."}
            />
        </>
    );
}
